import { gql } from '@apollo/client';

export const FEEDBACK_MUTATION = gql`
    mutation sendFeedback($feedback: FeedBackRequestInput!) {
        sendFeedback(feedback: $feedback)
    }
`;
